import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am an enthusiastic 
              <i>
                <b className="purple">
                  {" "}
                  Software Engineer{" "}
                </b>
              </i>
              with one year of professional industry experience and a recent Bachelor's graduate currently pursuing my Master's degree. My passion lies in transforming innovative ideas into reliable, scalable, and high-performance products.
              <br />
              <br />
              I thrive on building high-performance systems and crafting intuitive user experiences, constantly seeking ways to optimize efficiency across different platforms.
              <br />
              <br />
              I am proficient in 
              <i>
                <b className="purple">
                  {" "}
                  JavaScript, Node.js, and Java{" "}
                </b>
              </i>
              and I enjoy working across both backend and frontend stacks. My toolkit often includes building web applications with modern frameworks like 
              <i>
                <b className="purple">
                  {" "}
                  React.js and Next.js.
                </b>
              </i>
              <br />
              <br />
              In addition to 
              <i>
                <b className="purple">
                  {" "}
                  web development
                </b>
              </i>
              , I have experience and a strong interest in 
              <i>
                <b className="purple">
                  {" "}
                  Mobile App Development
                </b>
              </i>
              . I am keen on utilizing my programming skills to build seamless and engaging applications for both 
              <i>
                <b className="purple">
                  {" "}
                  iOS and Android{" "}
                </b>
              </i>
               users.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
